import { clasolSuiteApi } from './axiosConfig'

export * from './auth'
export * from './admin'
export * from './user/userActivity'
export * from './user/sessionSelectors'
export * from './user/userDashboardApi'

export const getHealth = async () => {
  const { data } = await clasolSuiteApi.get('/health')
  return data
}
